module.exports = __webpack_public_path__ + "static/media/face2.c9c07be6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/face2.svg
// module id = 972
// module chunks = 0